import { useMemo } from "react";
import { useParams } from "react-router-dom";

export const useNumberParams = <TRequired extends boolean = false>(
  required?: TRequired
): Record<string, TRequired extends true ? number : number | undefined> => {
  const params = useParams();

  return useMemo(
    () =>
      new Proxy(
        {},
        {
          get(_target, name) {
            if (typeof name !== "string") {
              console.error(
                "Symbol cannot be used as a key using `useNumberParams`"
              );

              // throw new Error(
              //   "Symbol cannot be used as a key using `useNumberParams`"
              // );

              return undefined;
            }

            const value = params[name];

            if (!value && required) {
              throw new Error(`Route param "${name}" is required`);
            }

            if (!value) {
              return undefined;
            }

            const parsedValue = Number.parseInt(value, 10);

            if (Number.isNaN(parsedValue)) {
              throw new Error(`Route param "${name}" has to be a number`);
            }

            return parsedValue;
          },
        }
      ),
    [params, required]
  );
};
